import { defineMessages } from "react-intl";

const baseId = "t.pages.Admin.TemporaryAbilitationsManagementStepOne.";

export default defineMessages({
  pageTitle: {
    id: baseId + "pageTitle",
    defaultMessage: "TEMPORARY ABILITATIONS MANAGEMENT",
  },
  CTABack: {
    id: baseId + "CTABack",
    defaultMessage: "Back",
  },
  applicationsManagementCard: {
    id: baseId + "applicationsManagementCard",
    defaultMessage: "Manage applications or add a new temporary abilitation",
  },
  temporaryAbilitationsManagementCard: {
    id: baseId + "temporaryAbilitationsManagementCard",
    defaultMessage: "Manage temporary abilitations",
  },
  noChangesMade: {
    id: baseId + "noChangesMade",
    defaultMessage: "No changes made.",
  },
});
